import { useState } from 'react'
import isEqual from 'lodash/isEqual'
import { LightspeedBusiness, LightspeedStore } from '../types'
import { useStoreIntegration } from './useStoreIntegration'

type PreconnectVariables = {
  storeId: string
  businessLocationId: string
  businessLocationName: string
}

export const usePreconnectStore = (
  selectedBusiness: LightspeedBusiness | null,
  connectedLocations: LightspeedStore[]
) => {
  const { disconnectStore, connectStore } = useStoreIntegration()
  const [lastConnectedSnapshot, setLastConnectedSnapshot] =
    useState<PreconnectVariables | null>(null)

  const preconnectStore = async (variables: PreconnectVariables | null) => {
    if (!selectedBusiness) return
    if (isEqual(variables, lastConnectedSnapshot)) return

    const shouldDisconnect =
      lastConnectedSnapshot &&
      !connectedLocations.some(
        ({
          id,
          store_integration_settings: { lightspeed_business_location_id }
        }) =>
          id === lastConnectedSnapshot?.storeId &&
          lightspeed_business_location_id ===
            lastConnectedSnapshot?.businessLocationId
      )

    if (shouldDisconnect) {
      await disconnectStore({
        storeId: lastConnectedSnapshot.storeId
      })
    }

    const shouldConnect =
      variables &&
      !connectedLocations.some(
        ({
          id,
          store_integration_settings: { lightspeed_business_location_id }
        }) =>
          id === variables?.storeId &&
          lightspeed_business_location_id === variables?.businessLocationId
      )

    if (shouldConnect) {
      await connectStore({
        storeId: variables.storeId,
        businessId: selectedBusiness.id,
        businessName: selectedBusiness.name,
        businessLocationId: variables.businessLocationId,
        businessLocationName: variables.businessLocationName
      })

      setLastConnectedSnapshot(variables)
    }

    if (!variables) {
      setLastConnectedSnapshot(null)
    }
  }

  return { preconnectStore }
}
